import { render, staticRenderFns } from "./MaintainerCropArticle.vue?vue&type=template&id=ec8843b4"
import script from "./MaintainerCropArticle.vue?vue&type=script&lang=js"
export * from "./MaintainerCropArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports